import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
const needs = ['A COMPLETE TRAINING SYSTEM.', 'PROFESSIONAL VISUAL INSTRUCTIONS.', 'STRUCTURED TEACHING RESOURCES.', 'TECHNICAL MACHINERY REFERENCES.', 'REALISTIC WORKPLACE SCENARIOS.', 'INSTRUCTOR ASSESSMENT TOOLS.', 'CLEAR TRAINING PROGRESSIONS.', 'BETTER LESSON PREPARATION.'];
const alreadyHave = ['You already have the forklift illustrations.', 'You already have the excavator technical diagrams.', 'You already have the bulldozer, loader and grader comparisons.', 'You already have the crane and lifting equipment references.', 'You already have the aerial platform training material.', 'You already have the road construction machinery diagrams.'];
export function ClosingArgument() {
  return <section className="py-20 px-4 bg-white border-y border-neutral-200" data-id="element-63" data-mp="215cqexe0wor5">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="max-w-3xl mx-auto text-center" data-id="element-64" data-mp="1wd2tuyiekqfw">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-neutral-900 mb-6 uppercase" data-id="element-65" data-mp="28zarl7l7erwl">
          You Don&apos;t Need More Random Heavy Equipment Training Material.
        </h2>
        <p className="text-xl text-neutral-800/80 mb-5" data-id="element-66" data-mp="2031tpxcvk1ck">You need:</p>
        <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2 mb-10" data-id="element-67" data-mp="1l6kg0zh7qamu">
          {needs.map(need => <li key={need} className="text-lg md:text-xl font-extrabold text-amber-600 tracking-wide" data-id="element-68" data-mp="1q89uyq7k38g7">
              {need}
            </li>)}
        </ul>
        <div className="bg-neutral-100 border border-neutral-200 rounded-2xl p-8 text-lg text-neutral-800 space-y-2 text-left sm:text-center" data-id="element-69" data-mp="1h5igsinapykv">
          <p className="mb-4" data-id="element-70" data-mp="36lq8o89pxnjm">
            With Heavy Equipment Instructor Atlas, you don&apos;t start every lesson searching through
            disconnected material.
          </p>
          {alreadyHave.map(line => <p key={line} className="text-neutral-900 font-semibold flex items-center sm:justify-center gap-2" data-id="element-71" data-mp="3931u4tyvq39e">
              <Check size={18} className="text-amber-600 shrink-0" aria-hidden="true" data-id="element-72" data-mp="305hpdb1t5ou1" />
              {line}
            </p>)}
          <p className="pt-4" data-id="element-73" data-mp="2v7pv4adoxqmo">
            And with the five professional bonuses... you also have additional written resources to
            plan, challenge, assess and review your students&apos; learning.
          </p>
          <p className="text-2xl md:text-3xl font-extrabold tracking-tight text-neutral-900" data-id="element-74" data-mp="3j3at2fk9a2sh">
            YOU ALREADY HAVE <span className="text-amber-600" data-id="element-75" data-mp="3e4zke85p5ybu">THE TRAINING FRAMEWORK.</span>
          </p>
        </div>
      </motion.div>
    </section>;
}